const capitalize = (text) => {
  return text.replace(/\b\w/g, (item) => item.toUpperCase());
};

export default capitalize;
